/**
 * @license
 * Copyright Tyler Technologies, Inc. 
 * License: Apache-2.0
 */
import { defineCustomElement } from '@tylertech/forge-core';
import { SelectComponent } from './select';
export * from './select-adapter';
export * from './select-constants';
export * from './select-core';
export * from './select';
export function defineSelectComponent() {
    defineCustomElement(SelectComponent);
}
